export default __webpack_public_path__ + "6380773cdd009d9410869e7e72d42e27.jpg";